export default __webpack_public_path__ + "static/media/competition_bar_left.c1fbfe69.png";